import React, { Component } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import {
  CarouselProvider,
  Slider,
  Slide,
  DotGroup,
  Dot
} from "pure-react-carousel";
import "pure-react-carousel/dist/react-carousel.es.css";
import Theme from "../utils/Theme";
import { FormattedMessage } from "react-intl";
import { getNotification } from "../selectors/notification";
import LoadingIndicator from "../components/LoadingIndicator";

const StyledContainer = styled.div`
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  position: fixed;
  overflow-y: hidden;
  z-index: 1000;
  background: rgba(0, 0, 0, 0.8);
`;

const StyledContent = styled.div`
  max-width: 500px;
  height: 80vh;
  width: 90vw;
  background: #fff;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  overflow-y: scroll;
  border-radius: 1em;
`;

const StyledImage = styled.img`
  width: 80%;
  max-width: 250px;
  position: relative;
  margin-top: 30px;
`;

const StyledHeader = styled.h1`
  position: relative;
  margin-top: 30px;
`;

const StyledDetails = styled.p`
  width: auto;
  position: relative;
  padding: 0 5%;
  line-height: 1.7em;
  font-size: 1em;
`;
const StyledQueueNo = styled.p`
  width: auto;
  position: relative;
  padding: 0 5%;
  margin-top: auto;
`;

const StyledGotItBtn = styled.div`
  border-radius: 25px;
  width: 50%;
  color: white;
  background: ${Theme.PrimaryColor};
  text-transform: uppercase;
  padding: 15px 0;
  margin-bottom: 10%;
  cursor: pointer;
`;

class NotificationModal extends Component {
  onGotItClicked = id => {
    /* put notification */
    const { onGotItClicked } = this.props;

    onGotItClicked(id);
  };

  onOkayClicked = () => {
    const { onOkayClicked } = this.props;
    onOkayClicked();
  };

  getNotificationSlider = notificationData => {
    return notificationData.map(data => {
      const dataTitle = data.title;
      const dataQueueNumber = data.queue_number;
      const stallNumber = () => {
        const stallNum = dataQueueNumber.split("-");
        return stallNum[0];
      };
      return (
        <Slide index={data.id} key={data.id}>
          <StyledContent>
            <StyledImage src={data.image.large.src} />
            <StyledHeader>
              <FormattedMessage
                id="notification.title"
                defaultMessage="Food is ready"
                description="Food is ready"
              />
            </StyledHeader>
            <StyledDetails>
              <FormattedMessage
                id="notification.details"
                defaultMessage="Your Food {dataTitle} of Queue {dataQueueNumber} is ready for pick up, please come over to stall: {stallNumber}"
                description="Food is Ready to pick up"
                values={{
                  dataTitle: dataTitle,
                  dataQueueNumber: dataQueueNumber,
                  stallNumber: stallNumber()
                }}
              />
            </StyledDetails>
            <StyledQueueNo>
              <FormattedMessage
                id="notification.queue.num"
                defaultMessage="Queue No. {dataQueueNumber}"
                description="Queue Number"
                values={{
                  dataQueueNumber: dataQueueNumber
                }}
              />
            </StyledQueueNo>
            <StyledGotItBtn onClick={() => this.onGotItClicked(data.id)}>
              <FormattedMessage
                id="notification.got.it.button"
                defaultMessage="Got It!"
                description="Got It!"
              />
            </StyledGotItBtn>
          </StyledContent>
        </Slide>
      );
    });
  };

  render() {
    const { notificationData, showNotification, loading } = this.props;

    const row =
      notificationData && notificationData ? notificationData.length + 1 : [];

    return showNotification ? (
      <StyledContainer>
        {loading ? <LoadingIndicator /> : null}
        <CarouselProvider
          naturalSlideWidth={100}
          naturalSlideHeight={500}
          totalSlides={row}
        >
          <DotGroup />
          <Slider>
            {this.getNotificationSlider(
              notificationData && notificationData ? notificationData : null
            )}
            <Slide index={row}>
              <StyledContent>
                <StyledImage
                  src={require("../assets/pickup_notification_banner.png")}
                />
                <StyledHeader>
                  <FormattedMessage
                    id="notification.last.title"
                    defaultMessage="Ready to Pick up"
                    description="Ready to Pick up"
                  />
                </StyledHeader>
                <StyledDetails>
                  <FormattedMessage
                    id="notification.last.details"
                    defaultMessage="Your Food is Ready to pick up, Click Okay to Check the Queue."
                    description="Your Food is Ready to pick up, Click Okay to Check the Queue."
                  />
                </StyledDetails>
                <StyledQueueNo />
                <StyledGotItBtn onClick={() => this.onOkayClicked()}>
                  <FormattedMessage
                    id="notification.okay.button"
                    defaultMessage="Okay"
                    description="Okay"
                  />
                </StyledGotItBtn>
              </StyledContent>
            </Slide>
          </Slider>
        </CarouselProvider>
      </StyledContainer>
    ) : null;
  }
}

NotificationModal.propTypes = {
  history: PropTypes.object.isRequired,
  notificationData: PropTypes.array,
  showNotification: PropTypes.bool,
  loading: PropTypes.bool,
  onGotItClicked: PropTypes.func,
  onOkayClicked: PropTypes.func
};

NotificationModal.defaultProps = {
  showNotification: false
};

export default NotificationModal;



// WEBPACK FOOTER //
// ./src/components/NotificationModal.js